import { get, flow } from 'lodash/fp';

export const getProcessing = get('processing');
export const getProcessingPercentage = flow(getProcessing, get('percentage'));
